
import { defineComponent, onBeforeMount, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { baseMixins } from '@common/mixins/baseMixins';
import { i18n } from '@tencent/vb-web-base';
import { isFusionBankApp } from '@tencent/vb-web-base-core';
import { getRedpointConfig } from '@common/core/network/NodeAPI';
import { queryAllCouponList } from '@common/core/network/TypeAPI';
import { INormalCoupon } from '@common/core/interface/IModel';
import AccountManager from '@common/core/manager/AccountManager';

export default defineComponent({
  name: 'TipsBottom',
  components: {},
  props: {
    hideLink: {
      type: Boolean,
      default: false,
    },
    tipState: {
      type: String,
      required: true,
    },
  },
  setup() {
    const { getT } = i18n;
    const $t = getT();
    // i18n.setLang('en-GB');
    const route = useRoute();
    const router = useRouter();
    const { gotoPro, isEng, inApp } = baseMixins();
    const accNo = ref('');

    const couponList = ref<INormalCoupon[]>([]);
    const showCouponRedPoint = ref(false);
    function bottomJump() {
      router.push({
        name: 'repayList',
        query: {
          status: 'ALL',
          ...route.query,
        },
      });
    }

    function jumpCommon() {
      const key = inApp ? 'loan_common' : 'loan_common_h5';
      gotoPro(key);
    }

    function jumpCoupon() {
      showCouponRedPoint.value = false;
      setStorage(
        `coupon_${accNo.value}`,
        couponList.value.map((item) => String(item.couponId)),
      );
      router.push({
        path: '/couponSelect',
        query: {
          ...route.query,
          showList: '1',
        },
      });
    }

    function jumpProto() {
      window.location.href = `/h5/contract/center/index.html?disableBusType=yes&title=Fusion Bank#/detailListNoLink`;
    }

    function getStorage(key: string) {
      try {
        const content = localStorage.getItem(key);
        return JSON.parse(content!);
      } catch (err) {
        return null;
      }
    }

    function setStorage(key: string, config: unknown) {
      const content = JSON.stringify(config);
      const res = localStorage.setItem(key, content);
      return res;
    }

    const init = async () => {
      const accountManager = await AccountManager.init();
      accNo.value = accountManager.getAccountNo();
      couponList.value = await queryAllCouponList(undefined, 1);
      const res = await getRedpointConfig();
      const couponConfig = res.find((item) => item.desc === 'coupon');
      if (couponConfig) {
        const couponStorage: string[] = getStorage(`coupon_${accNo.value}`);
        const newCouponList = couponList.value.filter((item) => !(couponStorage || []).includes(String(item.couponId)));
        if (newCouponList?.length > 0) {
          showCouponRedPoint.value = true;
        }
      }
    };

    onBeforeMount(() => {
      if (!inApp) {
        init();
      }
    });

    return {
      showCouponRedPoint,
      inApp,
      jumpCoupon,
      bottomJump,
      gotoPro,
      jumpProto,
      jumpCommon,
      isFusionBankApp,
      isEng,
    };
  },
});
